export const messages = {
  saasProductDevCompanyBtn: "Let’s Connect!",
  saasProductDevCompanyTitle: "Is Your SaaS Growth Stagnant?",
  saasProductDevCompanySubtitle: `Discover the Catalyst You've Been Searching For
  Leverage Our Decade-Long Expertise for Unprecedented Growth.`,
  endToEndProductDevBtn: "Get Started",
  endToEndProductDevTitle: "Experience the Future of SaaS!",
  endToEndProductDevSubtitle:
    "Enjoy Seamless Performance with an Impressive 99% Uptime and Lightning-Fast Response Times",
};
